import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { CreateExtractTasksMode } from '~src/extractTask/actions/CreateExtractTaskAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleDatasourceWithExtract, isSingleEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceInfo } from '../../../datasource/models/IDataSourceInfo';
import { IRefreshExtractAction } from '../../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { createExtractRefresh } from '../../actions/extractRefresh/CreateExtractRefreshAction';

export const ScheduleRefreshWithBridgeEntityAction: IEntityAction<IDataSourceInfo, IRefreshExtractAction> = {
  name: EntityActionNames.ScheduleRefreshWithBridge,
  translateName: Messages.bridgeLegacySchedule_action,

  isVisible: (targetItems: IDataSourceInfo[], appState: AppState) => {
    const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
    const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
    const isExtractSSSEnabled = isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;

    return isExtractSSSEnabled
      && isSingleDatasourceWithExtract(targetItems)
      && !isSingleEmbeddedDatasource(targetItems);
  },

  isClickable: (availableActions: IRefreshExtractAction, targetItems: IDataSourceInfo[]) => {
    const appState = getAppStore().getState();
    return currentUserIsOwnerOrAdmin(appState, targetItems[0]) || (availableActions && availableActions.refreshExtract);
  },

  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems, CreateExtractTasksMode.AllowScheduleOnlyOnClient)
};
